import { FC, ReactNode } from "react";
import LoadingSkeletons from "components/CustomComponents/SkeletonLoading";
// import DetailedStyles from "utilities/DetailedStyles";
import DetailTableTD from "components/CustomComponents/TablesCompoent/Detail/DetailTableTD";
import DetailePageStyles from "utilities/DetailePageStayles";

interface DetailTableTRProps {
    label: string;
    loading: boolean;
    children: ReactNode | string;
    colSpan?: number;
}

const DetailTableTR: FC<DetailTableTRProps> = ({ label, loading, children, colSpan = 2 }) => {
    const classes = DetailePageStyles();

    return (
        <tr className={classes.row}>
            <DetailTableTD
                className={classes.title}
                colSpan={colSpan}
            >
                {label}
            </DetailTableTD>
            <DetailTableTD
                colSpan={colSpan}
                className={classes.detail}
            >
                <LoadingSkeletons loading={loading}>
                    {children}
                </LoadingSkeletons>
            </DetailTableTD>
        </tr>
    )
}

export default DetailTableTR;